import { styled } from "styled-components";
import { measures } from "../lib/ui.js";

export const StyledDialogPanel = styled.div<{ $show: boolean; $isInPortrait: boolean }>`
    background-color: ${props => props.theme.backgroundColor};
    border-radius: 8px;
    box-shadow: 0 0 15px rgb(0 0 0 / 20%);
    display: flex;
    flex-direction: column;
    display: ${props => props.$show ? "block" : "none"};
    height: ${props => props.$isInPortrait ? measures.dialogPanel.portrait.height : measures.dialogPanel.landscape.height};
    position: absolute;
    width: ${props => props.$isInPortrait ? "100svw" : "80svw"};
    z-index:1000;
    .hr-text {
        line-height: 1em;
        position: relative;
        outline: 0;
        border: 0;
        color: ${(props) => props.theme.color ?? "unset"};
        text-align: center;
        height: 1em;
        opacity: 0.9;
       
}
`;
